import RegistriesSlice from './registries.slice';

export const { actions: registries_actions } = RegistriesSlice;

export default RegistriesSlice.reducer;
